import React from "react";
import { signOut } from "aws-amplify/auth";

export default function JSignOut() {
  const handleSignOut = async () => {
    try {
      await signOut();
      window.location.reload();
    } catch (error) {
      console.log("error signing out: ", error);
    }
  };

  return (
    <div onClick={handleSignOut} className="ui vertical animated button">
      <div className="visible content">Sign Out</div>
      <div className="hidden content">
        <i className="sign out alternate icon"></i>
      </div>
    </div>
  );
}
